import React from 'react'

function Messages() {
  return (
    <div className='messages'>Messages</div>
  )
}

export default Messages